import React from "react";
import { node } from "prop-types";
import Heading from "../Heading";
import Paragraph from "../Paragraph";
import { Col } from "../Grid";

const WhatIsNewContent = ({ children }) => {
	return (
		<Col sm={12} md={9} lg={9}>
			{children}
		</Col>
	);
};

WhatIsNewContent.propTypes = {
	children: node.isRequired,
};

const Title = ({ children }) => {
	return (
		<Heading Tag="h4" sx={{ fontSize: "m", fontColor: "white" }} spacing={{ mb: 4 }}>
			{children}
		</Heading>
	);
};

Title.propTypes = {
	children: node.isRequired,
};

const Description = ({ children }) => {
	return <Paragraph color="black--15">{children}</Paragraph>;
};

Description.propTypes = {
	children: node.isRequired,
};

WhatIsNewContent.Title = Title;
WhatIsNewContent.Description = Description;

export default WhatIsNewContent;
